import {getPagesByCategory} from "@/studio/utils/sanity-utils";
import {useRouter} from 'next/router';
import {useEffect, useState} from 'react';

import styles from "@/components/content/RelevantPages.module.css";
import Link from "next/link";

const RelevantPages = ({category}) => {
  const [pages, setPages] = useState([]);
  const router = useRouter();

  // Extract category from url if not provided in props
  if (!category) {
    category = router.pathname.split('/')[1];
  }

  // Get the current page's slug from the router
  const currentSlug = router.asPath.split('/').pop();

  useEffect(() => {
    const fetchData = async () => {
      const pagesData = await getPagesByCategory(category);
      // Filter out the current page by comparing slugs
      const filteredPages = pagesData.filter(page => page.slug !== currentSlug);
      setPages(filteredPages);
    }

    fetchData();

  }, [category, currentSlug]);

  return (
    pages.length > 0 && (
      <div className={styles.section}>
        <div className={styles.sectionTitle}>Relevant Pages</div>
        <div className={styles.sectionContent}>
          {pages.map((page, index) => (
            <Link href={`/knowledge/${page.slug}`} key={index}>
              <div className={styles.item}>
                <div className={styles.itemImage}>
                   {page.image && <img src={page.image} alt={page.title}/>}
                </div>
                <div className={styles.itemTitle}>{page.title}</div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    )
  );
};

export default RelevantPages;
